import { Typography } from "antd";
import SingleUploadPackageImage from "./SingleUploadPackageImage";

const UploadPackageImages = ({
  fileListA,
  setFileListA,
  fileListB,
  setFileListB,
  fileListC,
  setFileListC,
  fileListD,
  setFileListD,
  setIsDisabledButton,
}: any) => {
  return (
    <div className="w-full md:pl-5 xl:ml-0">
      <Typography className="mb-8 xl:h-[66px]">
        Dodaj slike događaja dimenzija 369 x 260 px Ove slike će se prikazati u
        gornjem dijelu akreditacije (u zavisnosti od paketa) koja se emailom
        šalje prisutnim koji su potvrđeni.
      </Typography>
      <div className="xl:flex justify-between w-full">
        <div className="mb-8 xl:mb-0 xl:w-[48%]">
          <SingleUploadPackageImage
            packageType="A"
            fileList={fileListA}
            setFileList={setFileListA}
            setIsDisabledButton={setIsDisabledButton}
          />
        </div>

        <div className=" xl:w-[48%]">
          <SingleUploadPackageImage
            packageType="B"
            fileList={fileListB}
            setFileList={setFileListB}
            setIsDisabledButton={setIsDisabledButton}
          />
        </div>
      </div>
      <div className="xl:flex justify-between w-full">
        <div className="mb-8 xl:mb-0  xl:w-[48%]">
          <SingleUploadPackageImage
            packageType="C"
            fileList={fileListC}
            setFileList={setFileListC}
            setIsDisabledButton={setIsDisabledButton}
          />
        </div>

        <div className="xl:w-[48%]">
          <SingleUploadPackageImage
            packageType="D"
            fileList={fileListD}
            setFileList={setFileListD}
            setIsDisabledButton={setIsDisabledButton}
          />
        </div>
      </div>
    </div>
  );
};

export default UploadPackageImages;
